import PageHeader from "../components/PageHeader";
import LatestBlogPost from '../components/Latest-Blog-Post'

const Blog = () => {

    return (
        <>
            <PageHeader pagetitle="Blog" breadcrumbMenu="Home" breadcrumbMenuActive="Blog" image="/images/blog-banner.jpg" />
            <LatestBlogPost />
        </>
    )
}

export default Blog